import { isItemClassMeetingMessage } from '../smimeItemClassUtils';
import CalendarItem from 'owa-service/lib/contract/CalendarItem';
import Item from 'owa-service/lib/contract/Item';
import formatMeetingTimeSpan from 'owa-timeformat/lib/utils/formatMeetingTimeSpan';
import { owaDate } from 'owa-datetime';

/**
 * @returns when and where displayed to user.
 */
const getWhenAndWhere = (item: Item): { when: string; where: string } => {
    if (isItemClassMeetingMessage(item.ItemClass)) {
        const calendarItem = <CalendarItem>item;
        return {
            when: calendarItem.Start
                ? formatMeetingTimeSpan(
                      owaDate(calendarItem.StartTimeZoneId, calendarItem.Start),
                      owaDate(calendarItem.EndTimeZoneId, calendarItem.End)
                  ) // TODO: Use long date and time formatters WI# 45543
                : null,
            where: calendarItem.Location?.DisplayName,
        };
    }
    return {
        when: null,
        where: null,
    };
};

export default getWhenAndWhere;
